<template>
    <div>
        <div class="itinerary-item">
            <p class="itinerary-item__title">
                {{ itemTime }} - {{ item.title }}
            </p>

            <p class="itinerary-item__body">{{ item.body }}</p>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import { SERVER_DATE_FORMAT, SERVER_TIME_FORMAT, LOCAL_DATE_FORMAT, LOCAL_TIME_FORMAT } from "@/constants.js";

    export default {
        props: ['item'],

        computed: {
            itemTime() {
                return moment(this.item.time, SERVER_TIME_FORMAT).format(LOCAL_TIME_FORMAT);
            }
        }
    }
</script>

<style scoped lang="scss">
    .itinerary-item {
        border-top: 1px dashed #e6e6e6;
        padding-top: 1rem;
        margin: 1rem 0;
        &__title{
            font-weight: 400;
        }
        &__body {
            margin-bottom: 5px;
            white-space: pre-wrap;
        }

    }
</style>